import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

function Recentsection() {
    const navigate = useNavigate();
    const data = useSelector((state) => state.auth.filterdata);
    const carouselRef = useRef(null);
    const item = data?.slice(0, 4)
    const items = item?.map((item) => (
        <div key={item.id} className={`bg-[#FAFAFA] p-3 rounded-md overflow-hidden shadow hover:shadow-lg transition duration-300 mx-1 my-3 ${data?.length == 1 ? "max-w-[350px]" : ""}`}>
            <div className="relative">
                <img
                    src={item.upload_logo}
                    alt={`Slide ${item.id}`}
                    onDragStart={(e) => e.preventDefault()}
                    onClick={() =>
                        navigate(`/franchise-opportunity/${item.id}`, {
                            state: { item: item },
                        })
                    }
                    role="presentation"
                    className="w-full h-60 object-cover cursor-pointer rounded-t-md"
                />
            </div>
            <div className="py-2">
                <p className="text-sm text-[#0C5399]">{item?.category?.name}</p>
                <h3 className="text-xl font-semibold text-[#222222] overflow-hidden overflow-ellipsis whitespace-nowrap mb-2">
                    {item?.brand_name}
                </h3>
                <div className="xl:min-h-[100px]">
                    <div className="flex justify-between text-sm text-gray-600 mb-[10px]">
                        <p className="flex-[0_0_50%] text-[#5D6C72]">Investment Range</p>
                        <p className="font-bold text-start flex-[0_0_50%]">
                            {item?.investment}
                        </p>
                    </div>
                    <div className="flex justify-between text-sm text-gray-600 mb-[10px]">
                        <p className="flex-[0_0_50%]">Area Required</p>
                        <p className="font-bold overflow-hidden overflow-ellipsis whitespace-nowrap text-start flex-[0_0_50%]">
                            {item?.required_area}
                        </p>
                    </div>
                    <div className="flex justify-between text-sm text-gray-600 mb-[10px]">
                        <p className="flex-[0_0_50%]">Franchise Outlets</p>
                        <p className="font-bold text-start flex-[0_0_50%] overflow-hidden overflow-ellipsis whitespace-nowrap">
                            {item?.brand_outlet}
                        </p>
                    </div>
                </div>
                <div
                    onClick={() => {
                        navigate(`/franchise-opportunity/${item?.brand_url}`, { state: { item: item } });
                        window.scrollTo(0, 0);
                    }}
                    className="rounded-md border-2 border-[#4A5661] text-[#4A5661] mt-1 text-center text-[16px] py-[7px] cursor-pointer hover:bg-[#4A5661] hover:text-white transition duration-200"
                >
                    View More
                    <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
                </div>
            </div>
        </div>
    ));

    const handleNext = () => {
        if (carouselRef.current) {
            carouselRef.current.slideNext();
        }
    };

    const handlePrev = () => {
        if (carouselRef.current) {
            carouselRef.current.slidePrev();
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    return (
        data?.length ?
            <div className="w-full max-w-[1250px] mt-[20px]    mx-auto xl:px-0 lg:px-0 md:px-5 px-4 pb-[50px] sm:mt-[100px] ">

                <h1 className="text-start font-bold 2xl:text-[32px] xl:text-[32px] lg:text-[32px] md:text-4xl text-2xl xl:mb-5 lg:mb-5 md:mb-5 mb-3">
                    You May <span className="text-[#0099C8]">Also Like</span>
                </h1>

                <div className={`${item?.length === 1 || item?.length === 2 || item?.length === 3 ? "Carsouleitemwidth" : ""}`}>
                    {item?.length === 1 || item?.length === 2 || item?.length === 3 ?
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 sm:gap-5 mx-auto md:gap-2-important lg:gap-0-important xl:gap-0-important gap-4">
                            {item?.map((item, index) => (
                                <div key={item.id} className={`bg-[#FAFAFA] p-3 rounded-md overflow-hidden shadow hover:shadow-lg transition duration-300 mx-1 my-3 ${data?.length == 1 ? "max-w-[350px]" : ""}`}>
                                    <div className="relative">
                                        <img
                                            src={item.upload_logo}
                                            alt={`Slide ${item.id}`}
                                            onDragStart={(e) => e.preventDefault()}
                                            onClick={() =>
                                                navigate(`/franchise-opportunity/${item.id}`, {
                                                    state: { item: item },
                                                })
                                            }
                                            role="presentation"
                                            className="w-full h-60 object-cover cursor-pointer rounded-t-md"
                                        />
                                    </div>
                                    <div className="py-2">
                                        <p className="text-sm text-[#0C5399]">{item?.category?.name}</p>
                                        <h3 className="text-xl font-semibold text-[#222222] overflow-hidden overflow-ellipsis whitespace-nowrap mb-2">
                                            {item?.brand_name}
                                        </h3>
                                        <div className="xl:min-h-[100px]">
                                            <div className="flex justify-between text-sm text-gray-600 mb-[10px]">
                                                <p className="flex-[0_0_50%] text-[#5D6C72]">Investment Range</p>
                                                <p className="font-bold text-start flex-[0_0_50%]">
                                                    {item?.investment}
                                                </p>
                                            </div>
                                            <div className="flex justify-between text-sm text-gray-600 mb-[10px]">
                                                <p className="flex-[0_0_50%]">Area Required</p>
                                                <p className="font-bold overflow-hidden overflow-ellipsis whitespace-nowrap text-start flex-[0_0_50%]">
                                                    {item?.required_area}
                                                </p>
                                            </div>
                                            <div className="flex justify-between text-sm text-gray-600 mb-[10px]">
                                                <p className="flex-[0_0_50%]">Franchise Outlets</p>
                                                <p className="font-bold text-start flex-[0_0_50%] overflow-hidden overflow-ellipsis whitespace-nowrap">
                                                    {item?.brand_outlet}
                                                </p>
                                            </div>
                                        </div>
                                        <div
                                            onClick={() => {
                                                navigate(`/franchise-opportunity/${item?.brand_url}`, { state: { item: item } });
                                                window.scrollTo(0, 0);
                                            }}
                                            className="rounded-md border-2 border-[#4A5661] text-[#4A5661] mt-1 text-center text-[16px] py-[7px] cursor-pointer hover:bg-[#4A5661] hover:text-white transition duration-200"
                                        >
                                            View More
                                            <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
                                        </div>
                                    </div>
                                </div>
                            ))
                            } </div> : (

                            <AliceCarousel
                                ref={carouselRef}
                                mouseTracking
                                items={items}
                                autoPlay={true}
                                infinite={true}
                                autoPlayInterval={2000}
                                disableDotsControls={true}
                                disableButtonsControls={true}
                                responsive={{
                                    0: { items: 1 },
                                    768: { items: 2 },
                                    1024: { items: 3 },
                                    1280: { items: 4 },
                                }}
                            />
                        )}


                </div>

            </div>
            : <></>
    );
}

export default Recentsection;
